import styled from 'styled-components';
import { StyleColor, NewStyleColor } from '../../../../../utils/styles-constants';

interface IconLinkProps {
	isYoutubeIcon: boolean;
}

interface ButtonProps {
	disabled: boolean;
}

const IconLink = styled('div')`
	position: absolute;
	top: 9px;
	left: 9px;
	z-index: 1;
	display: flex;
	align-items: center;
	justify-content: center;
	width: 30px;
	height: 22px;
	border-radius: 6px;
	background-color: ${(props: IconLinkProps) => props.isYoutubeIcon ? StyleColor.White : NewStyleColor.Blue450};

	svg {
		width: ${(props: IconLinkProps) => props.isYoutubeIcon ? '30px' : '14px'};
		height: ${(props: IconLinkProps) => props.isYoutubeIcon ? '22px' : '14px'};
		fill: ${(props: IconLinkProps) => props.isYoutubeIcon ? NewStyleColor.Red300 : StyleColor.White};
	}
`;

const ButtonAdd = styled('button')`
	position: absolute;
	top: 9px;
	right: 39px;
	display: flex;
	align-items: center;
	justify-content: center;
	width: 20px;
	height: 20px;
	padding: 0;
	border: 2px solid ${StyleColor.White};
	border-radius: 50%;
	background-color: transparent;
	outline: 0;
	cursor: pointer;

	${({ disabled }: ButtonProps) => disabled && `
		cursor: default;
		opacity: 0.5;
	`}

	&:hover {
		opacity: 0.8;
	}

	svg {
		width: 10px;
		height: 10px;
		fill: ${StyleColor.White};
	}
`;

export {
	IconLink,
	ButtonAdd,
};



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/Editor/EditPanel/LinkPanel/LinkPanelInput/styles.ts